import React from "react";
import styles from "./Table.module.css";

export const Table = () => {
    return (
        <div className={styles.container}>
            <div className={styles.header}>
                Данные по областям <span className={styles.headerStrong}></span>
            </div>
            <input
                type="text"
                placeholder="Поиск"
                className={styles.search}
            />
            <div className={styles.tableTitle}>
            Потребление продукции
            </div>
            <div className={styles.tableRow}>
              <span>Мясо КРС</span>
              <span>
                <b>201 т</b>
                <span style={{ color: "#888", fontWeight: 400, marginLeft: 4 }}>(40%)</span>
              </span>
            </div>
        </div>
    );
};   